import component from './pay-by-bill.component';

export default angular
  .module('fizyweb.paycell.payByBill', [])
  .component('fizyPaycellPayByBill', component).name;



// WEBPACK FOOTER //
// src/app/buy/pay-by-bill/pay-by-bill.module.ts